module.exports = __webpack_public_path__ + "img/blog-cover-new.64e7c642.png";